<template>
  <div class="warp">
    <div class="downLoad">
      <div class="moreTable" v-show="tableDate.length > 1">
        <div class="title">缴费单位</div>
        <div :class="tabidx == index? 'header se ':'header'" v-for="(item,index) in tableDate" :key="item.index"
             @click="tab(index)">
          <img
              :src="tabidx == index?require('../../../assets/img/tablefirmoff.png'):require('../../../assets/img/tablefirmon.png')"
              alt=""> {{ item.enterpriseName }}
        </div>
      </div>
      <div class="tableCon">
        <div class="content" id="pdfDom">
          <div class="tabheader">缴费通知单</div>
          <!--                <div class="firm">单位名称：{{currentTable.company}}</div>-->
          <div class="details">
            <table border="1" width="100%" height="100%" cellspacing="0" cellpadding="0" align="center">
              <tr>
                <th width="100rem">租户名称</th>
                <th width="100rem">租住房间号</th>
                <th width="100rem">计费周期</th>
                <th width="100rem">表号</th>
                <th width="80rem">起码</th>
                <th width="80rem">止码</th>
                <th>用量</th>
                <th>单价</th>
                <th>应缴费用（元）</th>
              </tr>
              <tr v-for="(item, index) in currentTable.childrenRoomDetails">
                <!--                租户名称-->
                <td v-if="index == 0"
                    :rowspan="currentTable.childrenRoomDetails && currentTable.childrenRoomDetails.length">
                  {{ currentTable.enterpriseName }}
                </td>
                <!--                房间号-->
                <td>{{ item.roomName }}</td>
                <!--                计费周期-->
                <td v-if="index == 0"
                    :rowspan="currentTable.childrenRoomDetails && currentTable.childrenRoomDetails.length">
                  {{ currentTable.billingCycle }}
                </td>
                <!--                表号-->
                <td>{{ item.meterNo }}</td>
                <!--                起码-->
                <td>{{ item.firstVal }}</td>
                <!--                止码-->
                <td>{{ item.lastVal }}</td>
                <!--                用量-->
                <td>{{ item.spreadVal }}</td>
                <!--                单价-->
                <td>{{ item.price }}</td>
                <!--                应缴费用-->
                <td>{{ item.cost }}</td>
              </tr>
              <tr>
                <td colspan="8">应缴费用小计（元）</td>
                <td>{{ currentTable.cost }}</td>
              </tr>
              <tr>
                <td>业主名称</td>
                <td colspan="3">{{ EnterpriseInfo.firmName }}</td>
                <td>打印时间</td>
                <td colspan="4">{{ currentTable.currentTime }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="operation">
        <el-button type="primary" @click="exportWord()">下载</el-button>
        <el-button type="danger" @click="$emit('hidden', false)">退出</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'
import JSZipUtils from 'jszip-utils'
import {saveAs} from 'file-saver'
import {defaulturl} from '../../../../config'
import HtmlDocx from 'html-docx-js';
import JSZip from 'jszip';

export default {
  props: ['tableDate'],
  data() {
    return {
      tabidx: 0,
      currentTable: {}
    }
  },
  mounted() {
    if (this.tableDate) {
      this.tab(0)
    }
  },
  computed: {
    EnterpriseInfo() {
      return this.$store.state.project.EnterpriseInfo
    },
  },
  methods: {
    tab(idx) {
      this.tabidx = idx
      this.currentTable = this.tableDate[idx]
      // console.log(this.tableDate[idx]);
    },
    // 导出 Word 文档
    exportWord() {
      const table = document.getElementById('pdfDom');
      // 获取要导出的表格
      if (!table) {
        console.error('Table element not found.');
        return;
      }
      // 创建一个空白的 Word 文档
      const doc = document.createElement('a');

      // 设置文档类型和名称
      doc.setAttribute('href', 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent('<html><body>' + table.outerHTML + '</body></html>'));
      doc.setAttribute('download', '缴费通知单.doc');

      // 点击链接，保存文档
      doc.click();

      doc.remo
    },
    // exportWord() {
    //   let docxsrc = defaulturl + "cost.docx";
    //   let docxname = '缴费通知单'
    //   let _this = this
    //   // 读取并获得模板文件的二进制内容
    //   JSZipUtils.getBinaryContent(docxsrc, function (error, content) {
    //     // docxsrc是模板。我们在导出的时候，会根据此模板来导出对应的数据
    //     // 抛出异常
    //     if (error) {
    //       throw error;
    //     }
    //
    //     // 创建一个PizZip实例，内容为模板的内容
    //     let zip = new PizZip(content);
    //     // 创建并加载docx templater实例对象
    //     let doc = new docxtemplater().loadZip(zip);
    //     // 设置模板变量的值
    //     doc.setData({
    //       ..._this.currentTable,
    //       enterpriseName: _this.currentTable.enterpriseName,
    //       billingCycle: _this.currentTable.billingCycle,
    //       childrenRoomDetails: _this.currentTable.childrenRoomDetails,
    //       cost: _this.currentTable.cost,
    //       firmName: _this.EnterpriseInfo.firmName,
    //       currentTime: _this.currentTable.currentTime,
    //     });
    //     try {
    //       // 用模板变量的值替换所有模板变量
    //       doc.render();
    //     } catch (error) {
    //       // 抛出异常
    //       let e = {
    //         message: error.message,
    //         name: error.name,
    //         stack: error.stack,
    //         properties: error.properties
    //       };
    //       // console.log(JSON.stringify({error: e}));
    //       throw error;
    //     }
    //
    //     // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
    //     let out = doc.getZip().generate({
    //       type: "blob",
    //       mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    //     });
    //     // 将目标文件对象保存为目标类型的文件，并命名
    //     saveAs(out, docxname);
    //   });
    // },
  }
}
</script>

<style scoped lang="less">
.warp {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.24);
  z-index: 999;

}

.downLoad {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 83vh;
  display: flex;

  .moreTable {
    width: 10vw;
    height: 100%;
    background-color: #fff;

    .title {
      height: 6.5vh;
      line-height: 6.5vh;
      padding-left: 1vw;
      font-size: 18rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }

    .header {
      width: 100%;
      height: 3.6vh;
      line-height: 3.6vh;
      background: #fff;
      font-size: 16rem;
      padding: 0 1vw;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }

    .se {
      background: rgba(13, 148, 255, 0.07);
    }
  }

  .tableCon {
    width: 60vw;
    height: 100%;
    background-color: #DADCE0;
    position: relative;

    .control {
      width: 12%;
      height: 16vh;
      position: absolute;
      bottom: 6vh;
      left: 0;
      // background-color: #060;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
    }

    .content {
      width: 76%;
      height: 98%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      padding: 5.6vh 1.65vw;

      .tabheader {
        font-size: 20rem;
        font-family: Source Han Serif CN;
        font-weight: bold;
        color: #333333;
        text-align: center;
        padding-bottom: 3vh;
      }

      .details {
        & > table {
          tr {
            height: 4vh;
            text-align: center;
          }

          .bigger {
            font-size: 24rem;
            font-family: Source Han Serif CN;
            font-weight: 500;
            color: #000000;
          }
        }
      }
    }
  }

  .operation {
    width: 8.3vw;
    height: 100%;
    background-color: #fff;
    padding: 16px 28px;

    & > button {
      display: block;
      margin-bottom: 56px;
      width: 100%;
      height: 40px;
      margin-left: 0;
    }

    & > button:nth-child(2) {
      background: #FD4238;
    }
  }
}
</style>